module.exports = __webpack_public_path__ + "img/application-rej.dd8badd2.svg";